/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiSeoLocationByPathReviewsListParams } from './model/apiSeoLocationByPathReviewsListParams';
import type { PaginatedProviderRatingList } from './model/paginatedProviderRatingList';

/**
 * Returns provider ratings for the SEO location at a page path.
 */
export const apiSeoLocationByPathReviewsList = (
  params: ApiSeoLocationByPathReviewsListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedProviderRatingList>({
    url: `/api/v7/seo-location/reviews/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiSeoLocationByPathReviewsListQueryKey = (
  params?: ApiSeoLocationByPathReviewsListParams
) => {
  return [`/api/v7/seo-location/reviews/`, ...(params ? [params] : [])] as const;
};

export const getApiSeoLocationByPathReviewsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSeoLocationByPathReviewsList>>,
  TError = ErrorType<unknown>
>(
  params: ApiSeoLocationByPathReviewsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSeoLocationByPathReviewsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiSeoLocationByPathReviewsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSeoLocationByPathReviewsList>>> = ({
    signal,
  }) => apiSeoLocationByPathReviewsList(params, signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSeoLocationByPathReviewsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiSeoLocationByPathReviewsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSeoLocationByPathReviewsList>>
>;
export type ApiSeoLocationByPathReviewsListQueryError = ErrorType<unknown>;

export function useApiSeoLocationByPathReviewsList<
  TData = Awaited<ReturnType<typeof apiSeoLocationByPathReviewsList>>,
  TError = ErrorType<unknown>
>(
  params: ApiSeoLocationByPathReviewsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSeoLocationByPathReviewsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiSeoLocationByPathReviewsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
